import { useState } from "react";
import { BtnActivityActionFormWidgetStyled } from "./styled";
import { ACTIVITY_FORM_RENDER_STATUS } from "utils/functions/activityForm";
import { Displays, Forms, Modals } from "components";

const BtnActivityActionFormWidget = ({
  data,
  value,
  onBgLoading,
  onSuccess,
  icon,
}) => {
  const [_renderModal, _setRenderModal] = useState(false);

  const _handleChange = () => {
    _setRenderModal(true);
  };
  const _handleCloseModal = () => {
    _setRenderModal(false);
  };

  // const _handleSubmit = async (values) => {
  //   _setRenderModal(false);
  //   onBgLoading(true);
  // };

  const renderStatus = ACTIVITY_FORM_RENDER_STATUS(value);
  return (
    <>
      <BtnActivityActionFormWidgetStyled>
        <div onClick={_handleChange}>
          {icon ? (
            icon
          ) : (
            <Displays.StatusLabel
              canEdit
              bg={renderStatus?.bg}
              label={renderStatus?.label}
            />
          )}
        </div>
      </BtnActivityActionFormWidgetStyled>
      <Modals.BodyEmpty
        isShowModal={_renderModal}
        onCloseModal={_handleCloseModal}
      >
        <Forms.ApproveActivityEditAnswerForm
          activity_form_id={data.activity_form_ref_id}
          activity_form_history_id={data._id}
          initialValues={data}
          onSuccess={onSuccess}
        />
      </Modals.BodyEmpty>
    </>
  );
};

export default BtnActivityActionFormWidget;
